module.exports = __webpack_public_path__ + "img/im_nav_hamburger.7da795a2.svg";